import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref, onMounted } from 'vue';
import { OrderAPI } from '@/api/order';
import { EventType } from '@/types/event';
import { sendMetrics } from '@/utils/metrics';
import { MetricTags } from '@/utils/tags';
import { UiButton } from '@huntflow/ui';
import { trlMessage } from '@/services/i18n';
export default /*@__PURE__*/ _defineComponent({
    __name: 'invoice-button',
    props: {
        id: {},
        initPrint: { type: Boolean, default: false },
        ticketType: { default: '' }
    },
    setup(__props) {
        const loading = ref(false);
        function initialPrint() {
            loading.value = true;
            const type = EventType[__props.ticketType].toLowerCase();
            const ticketTypeTarget = MetricTags[type];
            sendMetrics(ticketTypeTarget);
            OrderAPI.fetchInvoiceById(__props.id)
                .then((blob) => {
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `invoice_${__props.id}.pdf`;
                link.click();
                document.getElementById('app');
                URL.revokeObjectURL(url);
            })
                .catch((error) => {
                console.error('Ошибка при загрузке PDF:', error);
            })
                .finally(() => {
                loading.value = false;
            });
        }
        function handleFetchInvoice() {
            initialPrint();
        }
        onMounted(() => {
            if (__props.initPrint) {
                initialPrint();
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UiButton), {
                loading: loading.value,
                onClick: handleFetchInvoice,
                size: "l"
            }, {
                default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(trlMessage)('ticket.invoice')), 1)
                ]),
                _: 1
            }, 8, ["loading"]));
        };
    }
});
